import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import no from './locales/no.json';
import en from './locales/en.json';
import ro from './locales/ro.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      no: { translation: no },
      en: { translation: en },
      ro: { translation: ro }
    },
    lng: 'no',  // Force Norwegian as default
    fallbackLng: 'no',
    supportedLngs: ['no', 'en', 'ro'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['querystring', 'localStorage'],  // Only check URL param and localStorage, NOT browser
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    }
  });

export default i18n;
